module.exports = __webpack_public_path__ + "img/curve-3-3.74b1a770.svg";